import { Flex, Typography } from '@banhala/ui-kit';
import { CounterStepper } from '../ProductListView/CounterStepper';

export const InlineQuantityRow = ({
  count,
  stepperMaxCount,
  onChangeCount,
  lowStockCount,
  topPadding,
}: {
  count: number;
  stepperMaxCount: number;
  onChangeCount: (value: number) => void;
  lowStockCount: number | null;
  topPadding: number;
}) => (
  <Flex padding={{ top: topPadding, bottom: 12, horizontal: 16 }}>
    <Flex.Row alignItems={'center'} gap={12}>
      <Typography type={'body2'} color={'content_secondary'}>
        수량
      </Typography>
      <CounterStepper
        min={1}
        max={stepperMaxCount}
        value={count}
        onChangeValue={onChangeCount}
      />
      {lowStockCount !== null && (
        <Typography type={'body3'} color={'content_pink_primary'}>
          {lowStockCount}개 남음
        </Typography>
      )}
    </Flex.Row>
  </Flex>
);
